import { BrandDefinition } from '../brand.interface';
import { createDefaultBrandTexts, defineBrandConfig } from '../define-brand-config';
import { defineThemeVariables } from '../theme-variable';
import { logo as pymeRuralLogo } from './logo-base64';

const buildBrandAssetUrl = (assetPath: string): string => `assets/brands/pyme_rural/${assetPath}`;

const buildDefaultAssets = () => ({
  logoUrl: buildBrandAssetUrl('img/logo.png'),
  footerLogoUrl: buildBrandAssetUrl('svg/isologo-blanco.svg'),
  faviconUrl: buildBrandAssetUrl('img/favicon-32x32.png'),
  favicon16Url: buildBrandAssetUrl('img/favicon-16x16.png'),
  favicon32Url: buildBrandAssetUrl('img/favicon-32x32.png'),
});

export const pymeRuralBrand: BrandDefinition = {
  key: 'pyme_rural',
  config: defineBrandConfig({
    displayName: 'Pyme Rural',
    appName: 'PymeRural',
    siteTitle: 'Pyme Rural',
    copyrightLabel: 'Pyme Rural',
    assets: {
      ...buildDefaultAssets(),
      logoUrl: buildBrandAssetUrl('img/logo.png'),
    },
    links: {
      website: {
        label: 'mutualpymerural.ar',
        url: 'https://www.mutualpymerural.ar/',
      },
      apiDocsUrl: 'https://telepagos.com.ar/api/',
      termsUrl: 'https://www.mutualpymerural.ar/l/terminos-condiciones/',
      iosAppUrl: 'https://apps.apple.com/ar/app/pyme-rural/id6636554321',
      androidAppUrl:
        'https://play.google.com/store/apps/details?id=com.pymesrural&pcampaignid=web_share',
    },
    export: {
      movimientosFilePrefix: 'movimientos_pyme_rural',
    },
    texts: createDefaultBrandTexts('Pyme Rural'),
  }),
  logoBase64: pymeRuralLogo,
  themeVariables: defineThemeVariables({
    '--primary': '#083050',
    '--primary-op50': '#08305080',
    '--primary-op80': '#083050cc',
    '--primary-dark': '#062640',
    '--primary-darker': '#041a2d',
    '--nav-card-label-disabled': 'rgba(34, 49, 63, 0.4)',
    '--nav-card-icon-disabled': 'rgba(34, 49, 63, 0.4)',
  }),
};
